import { useCallback, useEffect, useState } from "react";
import {useSearchParams} from 'react-router-dom';
import { registrarObtenerPagoPowerpay } from "../../helpers";

export const useRegistrarObtenerPago = () => {

  const [state, setState] = useState({
    data:null,
    isLoading: false,
    hasError: null
  });

  const [searchParams] = useSearchParams();
  
  const registrarPagoAxios = async () => {
    setState({
      ...state,
      isLoading: true,
    });
        
    const transaction_status = searchParams.get('status');
    const transaction_id = searchParams.get('transaction_id');

    const data = await registrarObtenerPagoPowerpay(transaction_status, transaction_id);
    
    setState({
      data: data.datos,
      isLoading:false,
      hasError: !!data.mensajeError
    });
  }

  const registrarPago = useCallback(registrarPagoAxios, []);

  useEffect(() => {
    registrarPago();
  }, [registrarPago])

  return {
    data: state.data,
    isLoading: state.isLoading,
    hasError: state.hasError
  }
}
